import { render, staticRenderFns } from "./social-btn.vue?vue&type=template&id=0484a738&scoped=true&"
import script from "./social-btn.vue?vue&type=script&lang=js&"
export * from "./social-btn.vue?vue&type=script&lang=js&"
import style0 from "./social-btn.vue?vue&type=style&index=0&id=0484a738&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0484a738",
  null
  
)

export default component.exports